import { useParams } from "react-router-dom";
import { SubRoutingURLs } from "../common/RoutingURLs";
import MySchedule from "./MySchedule/MySchedule";
import { Box } from "@mui/material";
import { Toaster } from "react-hot-toast";
import PriestDailySchedulesReport from "./PriestDailySchedulesReport/PriestDailySchedulesReport";
import PriestAvailabilitySchedule from "./PriestAvailabilitySchedule/PriestAvailabilitySchedule";
import ViewPriestSchedule from "./ViewPriestSchedule/ViewPriestSchedule";

const SchedylesType = () => {
  const { scheduleType } = useParams();

  let componentToRender: JSX.Element;

  switch (scheduleType) {
    case SubRoutingURLs.MY_SCHEDULE:
      componentToRender = <MySchedule />;
      break;
    case SubRoutingURLs.PRIESTS_DAILY_SCHEDULE_REPORT_FOR_CHIEF_PRIEST:
      componentToRender = <PriestDailySchedulesReport />;
      break;
    case SubRoutingURLs.PRIESTS_AVAILABILITY_REPORT_FOR_CHIEF_PRIEST:
      componentToRender = <PriestAvailabilitySchedule />;
      break;
    case SubRoutingURLs.VIEW_PRIEST_SCHEDULE:
      componentToRender = <ViewPriestSchedule/>;
      break;
    case SubRoutingURLs.VIEW_HALL_SCHEDULE:
      componentToRender = <ViewPriestSchedule isHallSchedule={true}/>;
      break;
    default:
      componentToRender = <Box>Page not found</Box>;
  }

  return (
    <>
      <Toaster />
      {componentToRender}
    </>
  );
};

export default SchedylesType;
